import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const ChevronRightIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"/>
    </SvgIcon>
  );
};

ChevronRightIcon.propTypes = {}

ChevronRightIcon.defaultProps = {}

export default ChevronRightIcon;